import { getFormatDate } from './method';
import cs from './index.module.scss';
import cx from 'classnames';
import { useNotifyContext } from './hooks';

const Card = ({config}) => {
  const {
    title,
    content,
    createTime,
  } = config || {};
  const { context, setContext } = useNotifyContext();

  const onCardMouseEnter = () => {
    setContext({
      showAutoNotiContent: true,
    });
  };

  return (
    <div className={cs.cardWrapper}>

      <div onMouseEnter={onCardMouseEnter}>
        <div className={cx(cs.cardSubTitle, context.showAutoNotiContent ? '' : cs.twolines)}>
          {title}
        </div>

        <div className={cx(cs.cardCentent, context.showAutoNotiContent ? '' : cs.cardCententHide)}>
          <div className={cs.cardDesc}>
            {content}
          </div>

          <div className={cs.cardDate}>
            {getFormatDate(createTime)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
